import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalHeader, MDBModalTitle, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { getSMSBrand, getSpecificSMSBrandDetails } from '../../apiclients/streamsapi_bridge';
import AddSMSBrand from '../../components/topviews/addBrand';
import PopupLoaderNew from '../popups/PopupLoaderNew';
import DeleteSMSBrand from '../popups/globalaccount/brandAndSMS/DeleteSMSBrand';
import { Tooltip } from 'react-tooltip';
import { customSearch, useAutoFocusSearchAfterLoads } from '../../components/CustomSearchUtil/CustomSearch';
import UIConstant from '../../apiclients/UIConstant';
import TabIDConstant from '../../apiclients/TabIDConstant';

function SMSBrand({basicActive}) {
    const { t, i18n } = useTranslation();
    const [centredModal5, setCentredModal5] = useState(false);
    const navigate = useNavigate();
    const [internalError, setInternalError] = useState(false);
    const [isloading, setIsloading] = useState(false);
    const [brandList, setbrandList] = useState([]);
    const [brandId, setBrandId] = useState("");
    const [deleteBrand, setdeleteBrand] = useState(false);
    const deletetoggle = () => setdeleteBrand(!deleteBrand);
    const deletBrandRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);
    const [draftDetails, setdraftDetails] = useState({})
    const [isDraft, setisDraft] = useState(false);
    const [smsBrandDetails, setSmsBrandDetails] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [filteredIndices, setFilteredIndices] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    const [cnperror, setcnperror] = useState("");
useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,basicActive)
    function handleClick() {
        deletBrandRef.current.click();
    }

    const showThisInfo = (tdata) => {
        if (!(tdata.brandInfo.brand_status === "Saved As Draft")) {
            navigate("/brandcompanyregistration", {
                state: tdata.brandInfo,
            });
        }
    }

    useEffect(() => {
        if (basicActive) getSMSBrands();

    }, [basicActive]);


    async function getSMSBrands() {
        try {
            setInternalError(false);
            setIsloading(true);
            console.log(sessionStorage.getItem("admin_session"));
            const response = await getSMSBrand(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                TabIDConstant.SMS_BRANDS_SUBLINK
            );
            setIsloading(false);
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const rawData = await response.json();
            if (!rawData) {
                setInternalError(true);
            }
            console.log("setbrandList data :::::::::: " + JSON.stringify(rawData));
            setbrandList(rawData?.brands && Array.isArray(rawData?.brands) ? rawData?.brands : []);
            setTimeout(() => {
                setIsloading(false);
            }, 1000);


        } catch (error) {

        }
    }

    async function handleDaft(brand) {
        try {
            setIsloading(true);
            const response = await getSpecificSMSBrandDetails(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                brand.brand_id
            );
            setTimeout(() => {
                setIsloading(false);
            }, 1000);
            const brandDetails = await response.json();
            console.log(
                "getSpecific getBrandSpecificDetails ::: " +
                JSON.stringify(brandDetails)
            );
            setisDraft(true);
            setdraftDetails(brandDetails?.brands ?? {});
            toggleOpen5();

        } catch (error) { }

    }

    function handleDelete(e, brandid) {
        e.preventDefault();
        e.stopPropagation();
        setBrandId(brandid);
        deletetoggle();
    }

      useEffect(()=>{
    let processdrows = [];
    brandList && brandList.length > 0 && brandList.map((brand) => {

        processdrows.push({
            brandInfo: brand,
            name: brand?.brand_details?.brand_name?.toString() ?? "",
            brandid:
                ((typeof brand.brand_id === "string" && isNaN(Number(brand.brand_id)))
                    ? brand.brand_id
                    : ""),
            statusText: brand.brand_status?.toString() ?? "",
            status:
                brand.brand_status === "Saved As Draft" ? (
                    <a
                        onClick={(e) => {
                            e.preventDefault();
                            handleDaft(brand);
                        }}
                    >
                        Saved As Draft
                    </a>
                ) : (
                    <span>
                        {brand.brand_status}

                        {brand.brand_status?.toLowerCase() === "pending" && (
                            <i
                                className="fa-solid fa-circle-info cnpToolTip ms-1 text-secondary"
                                title=""  
                                onMouseOver={(e) => {
                                    e.preventDefault();
                                    setcnperror(
                                        "Your brand website validation was successful. It will take up to 48 hours for final confirmation, and you’ll receive an email once it’s approved"
                                    );
                                }}
                            ></i>
                        )}
                    </span>
                ),
            action: (
                <>

                    <div className="d-flex align-items-center ms-2">
                        <div className="custom-hover-bg p-1 ms-2 cursor-pointer deleteToolTip"
                            onClick={(e) => handleDelete(e, brand.brand_id)}
                        >
                            <MDBIcon fas icon="times" color="primary" className="mx-2 my-1 fs-5" />
                        </div>
                    </div>
                </>
            ),
            note: brand.brand_status === "PENDING" ? (
                <>
                    <p>
                        <strong>Note:</strong> Thank you for submitting your Brand request. Please allow up to 48 hours for approval. <br /> A notification will be sent via email to the Admin listed in the account to proceed with <br /> submitting your campaign.
                    </p>
                </>
            ) : "",



        })
      })
    setSmsBrandDetails(processdrows);
    setFilteredIndices(processdrows.map((_, i) => i));
    setDataLoaded(true)
    },[brandList,basicActive])

    const handleManualSearch = (value) => {
        setSearchValue(value);

        if (!smsBrandDetails || smsBrandDetails.length === 0) {
            setFilteredIndices([]);
            return;
        }

        if (!value.trim()) {
            setFilteredIndices(smsBrandDetails.map((_, i) => i));
            return;
        }

        const filterResult = customSearch(smsBrandDetails, value, UIConstant.SMSBRAND);
        const matchingIndices = filterResult
            .map(filteredItem => smsBrandDetails.indexOf(filteredItem))
            .filter(i => i !== -1);
        setFilteredIndices(matchingIndices);
    };

    const basicData2 = {
        columns: [
            { label: 'DBA Name', field: 'name', sort: true },
            { label: 'Brand ID ', field: 'brandid' },
            { label: 'Status', field: 'status' },
            { label: 'Remove', field: 'action', sort: false },
        ],
        rows: smsBrandDetails,
    };

    const toggleOpen5 = () => setCentredModal5(!centredModal5);

    useEffect(() => {
        const patchTitles = () => {
            const tds = document.querySelectorAll('table td');
            tds.forEach(td => {
                const trimmed = td.textContent.trim();
                if (!td.getAttribute('title') || td.getAttribute('title') !== trimmed) {
                    td.setAttribute('title', trimmed);
                }
            });
        };

        patchTitles();

        const table = document.querySelector('.smsBrandDataTable');

        if (!table) return;

        const observer = new MutationObserver(() => {
            patchTitles();
        });

        observer.observe(table, {
            childList: true,
            subtree: true,
        });

        return () => observer.disconnect();
    }, []);


    return (
        <>

            <div>
                <div className="d-flex align-items-center justify-content-between actionbar">
                    {/* <div className='me-2'>

                        <MDBBtn className="ms-2 btn_adjust" onClick={(e) => { e.preventDefault(); setisDraft(false); toggleOpen5(); }}>
                            <MDBIcon fas icon="plus" size="sm" className="me-2" /> {t("addBrand")}
                        </MDBBtn>
                    </div> */}
                </div>
                <div className='mb-2 mt-0 position-relative w-auto'>
                              <MDBInput 
                                label="Search" 
                                ref={searchRef}
                                value={searchValue} 
                                onChange={(e) => handleManualSearch(e.target.value)} 
                              />
                              <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                            </div>
                <div className="smsDataTable">
                    <MDBDatatable key={searchValue}
                    // search
                    data={{...basicData2, rows: filteredIndices.map(i => smsBrandDetails[i])}} entries={50} onRowClick={(e) => showThisInfo(e)} className='actioncolumn smsBrandDataTable' />
                </div>
            </div>
            <MDBModal open={centredModal5} onClose={() => setCentredModal5(false)} tabIndex='-1'>
                <MDBModalDialog size="fullscreen">
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle className="d-flex align-items-center justify-content-center">
                                {t('Brandregistration')}
                            </MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={toggleOpen5}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody className="fullPageModel">
                            <AddSMSBrand
                                closePopup={toggleOpen5}
                                draftDetails={isDraft ? draftDetails : null}
                            />
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >
                    Internal Server Error
                </MDBAlert>
            )}

            {deleteBrand && (
                <PopupLoaderNew
                    title={"Remove SMS Brand"}
                    content={<DeleteSMSBrand
                        brandId={brandId}
                        onClose={deletetoggle}
                        ref={deletBrandRef}
                        setIsloading={setisLoading}
                    />}
                    onShow={setdeleteBrand}
                    onClose={deletetoggle}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                />
            )}

            <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                Remove
            </Tooltip>
            <Tooltip anchorSelect=".cnpToolTip" place="right" className="exampleTooltipLight" style={{ maxWidth: "25%" }}>
                {cnperror}
            </Tooltip>
        </>
    )
}

export default SMSBrand
